import React from 'react';
import {
    CheckCircle,
    XCircle,
    Key,
    Loader2,
    Lock
} from 'lucide-react';
import type { PayPalValidationResult } from '@/services/payment/paypal-secrets-service';

interface PayPalKeyValidationStatusProps {
    isLoading: boolean;
    result: PayPalValidationResult | null;
}

const PayPalKeyValidationStatus: React.FC<PayPalKeyValidationStatusProps> = ({
    isLoading,
    result,
}) => {
    if (isLoading) {
        return (
            <div className="bg-background-secondary rounded-xl p-6 border border-border">
                <div className="flex items-center justify-center space-x-3">
                    <Loader2 className="w-6 h-6 text-primary animate-spin" />
                    <div>
                        <p className="text-foreground font-medium">Diagnostic en cours...</p>
                        <p className="text-sm text-foreground-secondary">
                            Vérification des capacités essentielles
                        </p>
                    </div>
                </div>
            </div>
        );
    }

    if (!result) {
        return null;
    }

    const getStatusIcon = (passed: boolean) => {
        return passed ? (
            <CheckCircle className="w-5 h-5 text-success" />
        ) : (
            <XCircle className="w-5 h-5 text-error" />
        );
    }

    return (
        <>

            {/* Diagnostic ultra-court */}
            <div className="bg-background-secondary overflow-hidden divide-y divide-border">
                {/* Auth */}
                <div className="p-4 flex items-center justify-between">
                    <div className="flex items-center space-x-4">
                        <div className="w-10 h-10 rounded-xl bg-background-tertiary flex items-center justify-center">
                            <Key className="w-5 h-5 text-foreground-secondary" />
                        </div>
                        <div>
                            <p className="font-semibold text-foreground">Clé API valide</p>
                            <p className="text-xs text-foreground-secondary">{result.tests.auth.message}</p>
                        </div>
                    </div>
                    {getStatusIcon(result.tests.auth.passed)}
                </div>

                {/* Creation */}
                <div className="p-4 flex items-center justify-between">
                    <div className="flex items-center space-x-4">
                        <div className="w-10 h-10 rounded-xl bg-background-tertiary flex items-center justify-center">
                            <CheckCircle className="w-5 h-5 text-foreground-secondary" />
                        </div>
                        <div>
                            <p className="font-semibold text-foreground">Création de paiement</p>
                            <p className="text-xs text-foreground-secondary">{result.tests.orderCreation.message}</p>
                        </div>
                    </div>
                    {getStatusIcon(result.tests.orderCreation.passed)}
                </div>
            </div>

        </>
    );
};

export default PayPalKeyValidationStatus;
